export default __webpack_public_path__ + "static/media/frog-nation-party.ae127e2d.jpeg";